<template>
  <v-container>
    <OverlayLoader :overlay="overlay" :text="'애플 로그인'" />
  </v-container>
</template>

<script>
import OverlayLoader from "@/components/OverlayLoader.vue";
export default {
  name: "AppleLogin",
  components: {
    OverlayLoader,
  },
  data() {
    return {
      overlay: true,
      name: undefined,
      email: undefined,
      result: undefined
    };
  },
  methods: {
    signIn() {
      var vm = this;
      this.$axios
        .post("/users/social/handle", {
          type: "apple",
          data: {
            name: this.name,
            email: this.email
          },
          token: this.token
        })
        .then(async (response) => {
          if (response.data.success) {
            await this.$store.dispatch("login", {
              body: response.data.result.auth_info,
            });

            this.overlay = false;
            if (response.data.first === true) {
              this.$router.push("/tutorial");
            } else {
              this.$router.push("/division");
            }
          }
        });
    }
  },
  mounted() {
    this.token = this.$route.query.token;
    this.name = this.$route.query.name;
    this.email = this.$route.query.email;
    this.signIn();
  }
};
</script>